import React from 'react'

import { useTranslation } from 'react-i18next'

import ExternalLink from '@components/shared/ExternalLink'
import { BasicEvent } from '@custom-types/activity'
import { formatRelativeTime } from '@utils/formatters/date.formatter'
import PageRoutes from '@utils/page-routes'

interface Props {
  event: BasicEvent
}

const BasicActivity: React.FC<Props> = ({ event }: Props) => {
  const { t } = useTranslation()
  const { action, actor } = event
  return (
    <div className="ml-3 flex-1 flex flex-row items-center">
      <span className="flex-1 flex flex-row items-center break-words">
        <ExternalLink
          className="underline-link mr-1 flex flex-row items-center"
          href={PageRoutes.userProfilePath(actor.external_id)}>
          {actor.username}
        </ExternalLink>
        {t(`event.${action}`)}
      </span>
      <span className="text-gray-text dark:text-gray-text-dm pl-2.5 text-xs whitespace-nowrap">
        {formatRelativeTime(event.when, new Date())}
      </span>
    </div>
  )
}

export default BasicActivity
